import { monthLabel } from '../lib/money';

export function MonthPicker({
  year,
  month,
  onPrev,
  onNext,
  onToday,
}: {
  year: number;
  month: number;
  onPrev: () => void;
  onNext?: () => void;
  onToday?: () => void;
}) {
  return (
    <div className="month-picker">
      <button className="secondary" onClick={onPrev} aria-label="Previous month">
        ‹
      </button>
      <div className="month-label">
        <strong>{monthLabel(year, month)}</strong>
        {onToday && (
          <button className="link" onClick={onToday}>
            Back to this month
          </button>
        )}
      </div>
      <button
        className="secondary"
        onClick={onNext}
        aria-label="Next month"
        disabled={!onNext}
      >
        ›
      </button>
    </div>
  );
}
